module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Pro Max Space Grey.298d7706.png";